import {
  Checkbox,
  Grid,
  InputAdornment,
  styled,
  TextField,
  Typography,
  useTheme
} from "@mui/material"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useState } from "react"
import SearchIcon from "assets/icons/Search.svg"
import { useDispatch, useSelector } from "react-redux"
import { useDebounce } from "hooks/utils"
import { Card } from "react-bootstrap"
import AppPagination from "components/StyledComponents/AppPagination"
import VantaMenuLogo from "assets/icons/VantaMenuLogo.svg"
import styles from "./groupLeaderBoard.module.scss"
import { getRestaurantGroupAction, getRestaurantsGroupListingsAction } from "redux/DMV/actions/user"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import AppButton from "components/StyledComponents/AppButton"
import { DMVActions } from "redux/DMV/slice/user"

const CustomSearchField = styled(TextField)(() => ({
  background: "transparent",
  border: "1px solid #C4C4C480",
  borderRadius: 8
}))

const StyledCard = styled(Card)(({ theme }) => ({
  background: "#000",
  border: "1px solid #C4C4C480",
  borderRadius: "16px",
  textAlign: "center",
  padding: "16px",
  cursor: "pointer",
  width: "100%",
  height: "100%",
  position: "relative",
  "&:hover": {
    border: `1px solid ${theme.palette.secondary.main}`,
    boxShadow: theme.palette.boxShadow.main
  }
}))

const RestaurantGroup = () => {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [searchValue, setSearchValue] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [selectedRestaurantGroup, setSelectedRestaurantGroup] = useState("")
  const theme = useTheme()
  const dispatch = useDispatch()
  const debouncedSearchTerm = useDebounce(searchValue, 500)
  const { restaurantsGroupListings } = useSelector((store) => store?.dmv)
  const history = useHistory()
  const handleSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  const filterResults = (searchQuery, results) => {
    if (searchQuery.trim() === "") {
      return results
    }
    return results?.filter((item) => {
      const { name, location } = item
      const includesSearchQuery = (string) =>
        string.toLowerCase().includes(searchQuery.toLowerCase())
      const nameMatch = searchQuery && includesSearchQuery(name)
      const locationMatch = location ? includesSearchQuery(location) : false

      return nameMatch || locationMatch
    })
  }

  const filteredResults = filterResults(debouncedSearchTerm, restaurantsGroupListings)

  const itemsPerPage = 8
  const totalPages = Math.ceil(filteredResults?.length / itemsPerPage)

  const filterRestaurantList = filteredResults?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  )

  const handleRestaurantGroup = (id) => {
    dispatch(DMVActions.setRestaurantsGroupID(id))
    history.push("/dmv/dashboard/restaurants-group/restaurants-list")
  }

  const handleRestaurantsGroup = (id) => {
    setSelectedRestaurantGroup((prevSelected) => (prevSelected === id ? "" : id))
  }

  useEffect(() => {
    document.title = "Restaurant Group"
    setBreadcrumbs(createBreadcrumbs())
    dispatch(getRestaurantsGroupListingsAction())
  }, [])

  return (
    <Grid container>
      <Grid item xs={12}>
        <Header title={"Group Leaderboard"} breadCrumbs={breadCrumbs}>
          <AppButton
            onClick={() => {
              history.push("/dmv/dashboard/group-leaderboard")
              dispatch(getRestaurantGroupAction({}))
            }}>
            View Listings
          </AppButton>
        </Header>
      </Grid>
      <Grid item xs={12} className={styles.mainContainer}>
        <Grid container gap={3} className={styles.container} justifyContent={"center"}>
          <Grid item xs={12} textAlign={"center"}>
            <Typography variant="body4Regular" color={theme.palette.text.secondary}>
              Please select the Parent Company from below to start creating Group leaderboard
            </Typography>
          </Grid>
          {restaurantsGroupListings?.length > 8 && (
            <Grid item xs={12}>
              <CustomSearchField
                type="search"
                autoComplete="off"
                value={searchValue}
                onChange={handleSearchField}
                placeholder="Search Parent Company..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={SearchIcon}
                        style={{
                          cursor: "pointer",
                          fontSize: "24px"
                        }}
                      />
                    </InputAdornment>
                  )
                }}
                fullWidth
              />
            </Grid>
          )}
          <Grid container spacing={2} justifyContent={"center"}>
            {filterRestaurantList?.length === 0 ? (
              <Grid item xs={12} className="d-flex justify-content-center">
                <Typography variant="h2" color={theme.palette.white.main}>
                  No Restaurants Found
                </Typography>
              </Grid>
            ) : (
              filterRestaurantList?.map((restaurant, index) => (
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={index}>
                  <StyledCard>
                    <Checkbox
                      onClick={() => {
                        handleRestaurantsGroup(restaurant?.id)
                      }}
                      checked={selectedRestaurantGroup === restaurant?.id}
                      className={styles.checkbox}
                    />
                    <img className={styles.image} src={restaurant?.icon || VantaMenuLogo} />
                    <Grid item xs={12} mb={0.5} mt={2}>
                      <Typography variant="body1Medium" color={theme.palette.text.secondary}>
                        {restaurant?.name}
                      </Typography>
                    </Grid>
                  </StyledCard>
                </Grid>
              ))
            )}
          </Grid>
          {restaurantsGroupListings?.length > 8 && (
            <Grid container justifyContent={"space-between"}>
              <Grid item mt={3}>
                <Typography variant="body2Regular" color={theme.palette.text.secondary}>
                  Showing {filterRestaurantList?.length} out of {restaurantsGroupListings?.length}{" "}
                  Results
                </Typography>
              </Grid>
              <Grid item>
                {filterRestaurantList?.length ? (
                  <AppPagination
                    onPageChange={setCurrentPage}
                    totalPages={totalPages}
                    currentPage={currentPage}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} mt={2}>
          <AppButton
            disabled={!selectedRestaurantGroup}
            styles={{ padding: "10px 40px" }}
            onClick={() => handleRestaurantGroup(selectedRestaurantGroup)}>
            Proceed
          </AppButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default RestaurantGroup
